<template>
  <div>
    <el-form ref="form" :model="searchForm" inline>
      <el-form-item>
        <el-select-shop
          v-model="searchForm.userIds"
          :options="shops_all"
          :multiple="false"
        />
        <!-- <el-select v-model="searchForm.userIds" clearable placeholder="店铺">
          <el-option v-for="shop in shops_all" :key="shop.userId" :value="shop.userId" :label="shop.title">
            <img :src="shop.icon" style="width: 20px; height: 20px" />{{ shop.title }}
          </el-option>
        </el-select> -->

      </el-form-item>
      <el-form-item style="margin-right: -1px">
        <el-select v-model="searchForm.queryType" style="width: 100px">
          <el-option v-for="(v, k) in enumQueryType" :key="k" :label="v" :value="k"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item style="margin-right: -1px">
        <el-select v-model="searchForm.searchType" style="width: 100px">
          <el-option v-for="item in enumMatchType" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-input-popup-editor v-model="searchForm.text" :autosize="{ minRows: 6 }" :placeholder="enumQueryType[searchForm.queryType]" />
      </el-form-item>
      <el-form-item>
        <el-select v-model="searchForm.uploadSuccess" clearable placeholder="上传结果" style="width: 100px">
          <el-option v-for="item in enumUploadSuccess" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-date-picker
          v-model="searchForm.time"
          type="datetimerange"
          value-format="yyyy-MM-dd HH:mm:ss"
          start-placeholder="开始时间"
          end-placeholder="结束时间"
          :picker-options="pickerOptions"
        />
      </el-form-item>
      <el-form-item>
        <el-button @click="search" type="primary">查询</el-button>
        <el-button @click="clear">清空</el-button>
      </el-form-item>
    </el-form>
    <el-table :data="datalist" style="max-height: calc(100vh - 220px)">
      <el-table-column v-for="col in columns" :key="col.field" :label="col.title" :prop="col.field">
        <template slot-scope="{ row }">
          <template v-if="col.field === 'numSkuId'">{{ row.numIid }}({{ row.skuId || '-' }})</template>
          <template v-else-if="col.field === 'operateTime'">{{ row[col.field] | todate }}</template>
          <template v-else>{{ row[col.field] }}</template>
        </template>
      </el-table-column>
    </el-table>
    <Pagination
      style="text-align: right; margin-top: 10px"
      :total="pagination.total"
      :limit.sync="pagination.pageSize"
      :page.sync="pagination.pageNo"
      @pagination="getList"
    />
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import { reqList } from './service';
import { pickerOptions } from '@/pages/supplier/prod/log/util';
import Pagination from '@/components/pagination.vue';
import dayjs from 'dayjs';

// search form params
const getSearchForm = () => {
  return {
    userIds: '',
    text: '',
    searchType: 0,
    queryType: 'outerId',
    uploadSuccess: '',
    // startTime: '',
    // endTime: '',
    time: [],
    pageNo: 1,
    pageSize: 50,
  };
};

// columns
const getColumns = () => {
  return [
    { field: 'kmtOuterId', title: '款式编码', visible: 1 },
    { field: 'kmtSkuOuterId', title: '商品编码', visible: 1 },
    { field: 'numSkuId', title: '平台商品id(平台规格id)', width: 150, visible: 1 },
    { field: 'shopName', title: '店铺', visible: 1 },
    { field: 'platTitle', title: '平台商品名称', visible: 1 },
    { field: 'platOuterId', title: '平台商家编码', visible: 1 },
    { field: 'operateTime', title: '操作时间', visible: 1 },
    { field: 'staffName', title: '操作人', visible: 1 },
    { field: 'uploadResult', title: '上传结果', visible: 1 },
    { field: 'uploadDetail', title: '上传详情', visible: 1 },
  ];
};

export default {
  name: 'stock-upload-log',
  components: {
    Pagination,
  },
  filters: {
    todate(value, format = 'YYYY-MM-DD HH:mm:ss') {
      if (!value) return value;
      return dayjs(value).format(format);
    },
  },
  data() {
    return {
      searchForm: getSearchForm(),
      pagination: { total: 0 },
      columns: getColumns(),
      datalist: [],
    };
  },
  computed: {
    ...mapGetters(['shops_all']),
  },
  methods: {
    getSearchParams() {
      const { userIds, time, ...restFormParams } = this.searchForm;
      const [startTime, endTime] = time;
      return {
        userIds: userIds == '' ? -1 : userIds,
        startTime: startTime ? dayjs(startTime).valueOf() : '',
        endTime: endTime ? dayjs(endTime).valueOf() : '',
        ...restFormParams,
      };
    },
    getList() {
      reqList(this.getSearchParams()).then(res => {
        this.datalist = res.data?.list || [];
        this.pagination.total = res.data?.total || -1;
      });
    },
    search() {
      this.searchForm.pageNo = 1;
      this.getList();
    },
    clear() {
      this.searchForm = getSearchForm();
      this.getList();
    },
  },
  beforeCreate() {
    this.enumQueryType = {
      outerId: '主商家编码',
      platTitle: '平台商品名称',
      platOuterId: '平台商家编码',
    };
    this.enumMatchType = [
      { label: '模糊搜索', value: 0 },
      { label: '精确搜索', value: 1 },
    ];
    this.enumUploadSuccess = [
      { label: '成功', value: true },
      { label: '失败', value: false },
    ];
    this.pickerOptions = pickerOptions;
  },
  created() {
    this.getList();
  },
};
</script>
